import Styled from 'styled-components';
import {transparentize} from 'polished';
export const Container = Styled.div`
	font-family: ${props => props.theme.fontFamily};
	width: 100%;
	height: 30px;
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;

`;

export const ButtonContainer = Styled.div`
	cursor: pointer;
	color: ${props => (props.isSelected ? props.theme.colors.white : props.theme.colors.textGray)};
	flex-grow: 1;
	height: 100%;
	display: flex;
	align-items: center;
	background-color: ${props => (props.isSelected ? props.theme.colors.forecastPurple : props.theme.colors.veryVeryLightGray)};
	&:hover {
		opacity: 0.8;
	}
`;

export const Text = Styled.div`
	text-transform: uppercase;
	font-size: 10px;
	letter-spacing: 1px;
	font-weight: 500;
	flex-grow: 1;
	text-align: center;
	border-left: ${props => `1px solid ${props.left ? transparentize(0.85, props.theme.colors.textGray) : 'transparent'}`};
	border-right:${props => `1px solid ${props.right ? transparentize(0.85, props.theme.colors.textGray) : 'transparent'}`};
`;
